// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
import englishTranslation from "@/translations/en";
// SPDX-License-Identifier: AGPL-3.0-only
export var getAttributeLabel = function (displayName) {
    var _a;
    if (displayName === null || displayName === void 0 ? void 0 : displayName.includes("$")) {
        return ((_a = displayName
            // Step 1: Remove '${' from the start and '}' from the end
            .replace(/^\${|}$/g, "")
            // Step 2: Remove any leading or trailing whitespace
            .trim()
            // Step 3: Add a space between a lowercase letter followed by an uppercase letter
            .replace(/([a-z])([A-Z])/g, "$1 $2")
            // Step 4: Capitalize the first letter
            .replace(/^./, function (match) { return match.toUpperCase(); })) !== null && _a !== void 0 ? _a : "");
    }
    return displayName !== null && displayName !== void 0 ? displayName : "";
};
export var getTranslationLabel = function (name, displayName, t) {
    if (name && name in englishTranslation.translations.usersAndRolesScreen.users.fields) {
        return t("usersAndRolesScreen.users.fields.".concat(name));
    }
    return getAttributeLabel(displayName !== null && displayName !== void 0 ? displayName : "");
};
export var userBasicInfo = ["first_name", "last_name", "email", "username"];
export var formatUserAtributes = function (attributes) {
    var newUserAttributesObject = {};
    if (attributes) {
        Object.entries(attributes).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (key !== "tenant-id") {
                newUserAttributesObject["".concat(key)] = value;
            }
        });
        return newUserAttributesObject;
    }
    return null;
};
